import { Size } from '../../../../core/types/ui/size';
import { IPosition2d } from '../../../../core/types/ui/position';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { Rect } from 'react-konva';

interface ColumnFilterrRootProps
  extends Size,
    IPosition2d,
    Pick<UseSheetTheme, 'stroke' | 'secondaryFill'> {}

const ColumnFilterRoot: React.FC<ColumnFilterrRootProps> = ({
  x,
  y,
  width,
  height,
  stroke,
  secondaryFill,
}) => {
  return (
    <Rect
      x={x}
      y={y}
      height={height}
      width={width}
      stroke={stroke}
      strokeWidth={1}
      hitStrokeWidth={0}
      fill={secondaryFill}
    />
  );
};

export default ColumnFilterRoot;
